import { render, staticRenderFns } from "./Luo6.vue?vue&type=template&id=5652d304&"
import script from "./Luo6.vue?vue&type=script&lang=js&"
export * from "./Luo6.vue?vue&type=script&lang=js&"
import style0 from "./Luo6.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports